module.exports = __webpack_public_path__ + "static/media/cq_file_export.33112806.svg";